/* ==========================================================================
   Thinbi Theme JS — Sticky ATC, Accordion, Email Popup, Mobile Menu
   ========================================================================== */

(function() {
  'use strict';

  /* --------------------------------------------------------------------------
     1. Accordion Toggle
     -------------------------------------------------------------------------- */
  document.querySelectorAll('.acc-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      trigger.closest('.acc-item').classList.toggle('open');
    });
  });

  /* --------------------------------------------------------------------------
     2. Subscribe & Save Toggle
     -------------------------------------------------------------------------- */
  document.querySelectorAll('.ss-module__option').forEach(function(option) {
    option.addEventListener('click', function() {
      var module = option.closest('.ss-module');
      module.querySelectorAll('.ss-module__option').forEach(function(opt) {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
    });
  });

  /* --------------------------------------------------------------------------
     3. Email Capture Pop-up
     -------------------------------------------------------------------------- */
  window.addEventListener('load', function() {
    if (!localStorage.getItem('thinbi_popup_seen')) {
      setTimeout(function() {
        var popup = document.getElementById('thinbi-popup');
        if (popup) {
          popup.classList.remove('hidden');
        }
      }, 4000);
    }
  });

  window.thinbiClosePopup = function() {
    var popup = document.getElementById('thinbi-popup');
    if (popup) {
      popup.classList.add('hidden');
      localStorage.setItem('thinbi_popup_seen', 'true');
    }
  };

  /* --------------------------------------------------------------------------
     4. Mobile Menu Toggle
     -------------------------------------------------------------------------- */
  var hamburger = document.querySelector('.thinbi-nav__hamburger');
  var mobileMenu = document.querySelector('.thinbi-mobile-menu');
  var mobileClose = document.querySelector('.thinbi-mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function() {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  /* --------------------------------------------------------------------------
     5. Announcement Bar Rotation
     -------------------------------------------------------------------------- */
  var announcements = document.querySelectorAll('.thinbi-announcement__msg');
  if (announcements.length > 1) {
    var currentIndex = 0;
    announcements.forEach(function(msg, i) {
      if (i > 0) msg.style.display = 'none';
    });

    setInterval(function() {
      announcements[currentIndex].style.display = 'none';
      currentIndex = (currentIndex + 1) % announcements.length;
      announcements[currentIndex].style.display = '';
    }, 4000);
  }

  /* --------------------------------------------------------------------------
     6. Sticky ATC — Show/hide on scroll (mobile)
     -------------------------------------------------------------------------- */
  var stickyAtc = document.querySelector('.thinbi-sticky-atc');
  if (stickyAtc) {
    var atcButton = document.querySelector('.thinbi-atc-main');
    if (atcButton) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyAtc.style.transform = 'translateY(100%)';
          } else {
            stickyAtc.style.transform = 'translateY(0)';
          }
        });
      }, { threshold: 0 });
      observer.observe(atcButton);
    }
    stickyAtc.style.transition = 'transform 0.3s ease';
  }

  /* --------------------------------------------------------------------------
     7. Smooth scroll to reviews
     -------------------------------------------------------------------------- */
  document.querySelectorAll('.info-col__stars').forEach(function(el) {
    el.addEventListener('click', function() {
      var reviews = document.querySelector('.thinbi-reviews');
      if (reviews) {
        reviews.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* --------------------------------------------------------------------------
     8. Mobile full-bleed gallery (v3 — 2026-08-13)

     The PDP gallery is mounted by an inline script in
     sections/custom-product-page.liquid at perPage 3 on mobile. Splide
     exposes no CSS hook for perPage, so it has to change in JS.

     WHY v1 AND v2 FAILED: this file is deferred in <head> BEFORE the
     Splide CDN script. Deferred scripts run in document order, so at the
     time this executes, window.Splide does not exist yet. Both earlier
     versions tested for Splide up front and returned immediately, so the
     poll loop never ran at all.

     Fix: poll for BOTH the Splide global and the mounted instance inside
     the interval. Nothing is checked before the loop starts.

     Desktop untouched — exits immediately at 750px and above.
     -------------------------------------------------------------------------- */
  function thinbiMobileGallery() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    var el = document.getElementById('pdp-gallery-splide');
    if (!el) return;

    var MOBILE_OPTS = {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '0px',
      padding: 0,
      arrows: true,
      pagination: true,
      drag: true
    };

    var tries = 0;
    var timer = setInterval(function() {
      tries++;

      // Splide may not have loaded yet — keep waiting, do not bail out.
      if (typeof Splide === 'undefined') {
        if (tries > 50) clearInterval(timer);
        return;
      }

      var instance = el.splide;

      if (instance) {
        clearInterval(timer);
        try {
          instance.options = MOBILE_OPTS;
          instance.refresh();
        } catch (e) {
          try {
            instance.destroy(true);
            new Splide(el, MOBILE_OPTS).mount();
          } catch (e2) { /* leave the original gallery alone */ }
        }
        return;
      }

      // Splide exists but the section never mounted an instance — mount ours.
      if (tries > 50) {
        clearInterval(timer);
        try {
          new Splide(el, MOBILE_OPTS).mount();
        } catch (e3) { /* leave the original gallery alone */ }
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', thinbiMobileGallery);
  } else {
    thinbiMobileGallery();
  }

})();
